// extracted by mini-css-extract-plugin
export default {"container":"Search_container__NmGAp"};